import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { setSsrStatus } from "./actions";
import { updateLeadSource } from "../settings/actions";
import { getPdiIntentData } from "../pre-delivery-inspection-intent/actions";
import { setGaSource } from "../../shared/ga-source/actions";

const mapStateToProps = ({
    preDeliveryInspection: { isSsr, cmsDetails },
    gaSource: { source }
}) => ({
    isSsr,
    cmsDetails,
    source
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPdiIntentDataConnect: getPdiIntentData,
    setSSRStatusConnect: setSsrStatus,
    updateLeadSourceConnect: updateLeadSource,
    setGaSourceConnect: setGaSource
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
